import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { TourAveragesData, TourAveragesVersion } from 'types/admin/tourAverages';
import { getErrorMessage } from 'utilities/ErrorHelper';
import { tourAveragesQueryKey } from './useTourAverages';

export const useSaveTourAverages = (version: TourAveragesVersion) => {
  const service = useServices().tourAveragesEditorService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (data: TourAveragesData) => {
      const request = { ...data, version };

      if (request.id) {
        return service.updateTourAverages(request);
      }

      const { id, ...newTourAverages } = request;
      return service.saveNewTourAverages(newTourAverages);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: tourAveragesQueryKey(version) });
      notificationsStore.addToast('success', 'Table has been saved successfully', 'success');
    },
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
  });
};
